import React, { FC } from 'react'
import { Redirect } from 'react-router-dom'
import { selectIsAuthenticated } from '../store/selectors/authSelectors'
import { useAppSelector } from '../hooks/useAppSelector'

const NotEnoughPrivilege: FC = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)

  if (!isAuthenticated) {
    return <Redirect to={{ pathname: '/login' }} />
  }

  return <h2 className="ms-auto me-auto mt-5">Not Enough Privilege</h2>
}

export default NotEnoughPrivilege
